import type { AutosaveState } from '@/hooks/useDebouncedAutosave'
import type { AttestationFormData } from '@/types/attestation'

/**
 * Props for AttestationScreen component
 * Contains form state and handlers
 */
export interface AttestationScreenBaseProps {
  formData: AttestationFormData
  loading: boolean
  error: string
  /**
   * Per-field messages keyed by the *server's* field name, as returned in the
   * `missing_fields` list of a 400 from `POST /attestations/{id}/submit`. Shown
   * next to the control rather than in the banner, so "affirmation" points at
   * the affirmation checkbox instead of at nothing in particular.
   */
  fieldErrors: Record<string, string>
  /** Draft autosave status, rendered as a quiet line under the form. */
  saveState: AutosaveState
  onFormDataChange: (updates: Partial<AttestationFormData>) => void
  onSubmit: (e: React.FormEvent) => void
}

/**
 * Default form data for attestation.
 *
 * The year is the *current* year rather than a hard-coded one: the server
 * rejects an attestation year in the future and reports `attestation_year` as
 * missing, so a stale constant becomes a silent submit failure every January.
 */
export const getDefaultFormData = (): AttestationFormData => ({
  attestation_year: new Date().getFullYear(),
  individual_income_test: false,
  joint_income_test: false,
  net_worth_test: false,
  country: '',
  market_insights_opt_in: true,
  affirmation: false,
})
